import { useCallback, useEffect, useState } from "react";
import { projectsApi } from "../api/projectsApi";
import { apiEnabled } from "../config/appConfig";
import fallbackProjects from "../data/projectsFallback.json";

export function useProjects() {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProjects = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    if (!apiEnabled) {
      setProjects(fallbackProjects);
      setError("Using fallback projects because API is not configured.");
      setIsLoading(false);
      return;
    }
    try {
      const res = await projectsApi.getProjects();
      const apiProjects = Array.isArray(res.data) ? res.data : [];

      if (apiProjects.length > 0) {
        setProjects(apiProjects);
      } else {
        setProjects(fallbackProjects);
        setError("Using fallback projects because API returned no data.");
      }
    } catch {
      setProjects(fallbackProjects);
      setError("Using fallback projects because API is unavailable.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { projects, isLoading, error, refresh: fetchProjects, setProjects };
}
